"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.secKey = exports.expires = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const secKey = process.env.REACT_APP_KEY || 'SVBReactSecretSessionsKey';
exports.secKey = secKey;
const expires = process.env.REACT_APP_EXPIRE || 1;
exports.expires = expires;